<cmps-wait-status *ngIf="state?.pending?.config"></cmps-wait-status>

<ng-container
    *ngIf="!state?.pending?.config && state?.configs[state?.activeConfig]"
>
    <div cmpsInsightSelectionCollapse>
        <div class="insight-group-1">
            <div
                cmpsInsightPersist
                [isDefault]="context.isDefault"
                [isFavourite]="context.isFavourite"
                [disallowSetDefault]="
                    state?.configs[state?.activeConfig]?.disallowSetDefault
                "
                [disallowSetFavourite]="
                    state?.configs[state?.activeConfig]?.disallowSetFavourite
                "
                (defaultClick)="setDefault.emit($event)"
                (favouriteClick)="setFavourite.emit($event)"
            ></div>

            <div data-insight-snce-summary>
                <div
                    cmpsInsightSelectionSummary
                    [periodType]="state?.period?.periodType"
                    [cacheDates]="cacheDates"
                    [eventDate]="state?.period?.eventDate"
                    [quickSwitch]="state?.superGroup?.quickSwitch"
                    [quickSwitchItem]="state?.superGroup?.active"
                    [quickSwitchLabel]="i18n._147_SUPERGROUPS"
                ></div>

                <!--TODO tl-->
                <button
                    class="btn bg-transparent cmps-cdk-py-0dot5"
                    data-insight-snce-toggle="show"
                    cmpsTooltipTrigger="Change selection"
                >
                    <cmps-icon svgIcon="pencil-outline"></cmps-icon>
                </button>
            </div>
        </div>

        <div class="insight-group-2">
            <div data-insight-snce-full>
                <div>
                    <div
                        class="mb-3"
                        cmpsInsightPeriod
                        [allowedPeriodTypes]="
                            state?.configs[state?.activeConfig]?.periods
                        "
                        [periodType]="state?.period?.periodType"
                        (periodTypeChange)="onPeriodTypeChange($event)"
                        [cacheDates]="cacheDates"
                        [eventDate]="state?.period?.eventDate"
                        (eventDateChange)="onEventDateChange($event)"
                        [canSelectEventDate]="canSelectEventDate"
                    ></div>

                    <ng-container
                        *ngIf="
                            !state?.pending?.configReload &&
                            !state?.period?.pending?.periodType &&
                            !state?.superGroup?.pending &&
                            state?.period?.eventDate &&
                            !state?.period?.gotoDashboard &&
                            state?.superGroup?.active
                        "
                    >
                        <div
                            cmpsHumanInsightSuperGroup
                            [cacheDates]="cacheDates"
                            [eventDate]="state?.period?.eventDate"
                            [selected]="state?.superGroup?.active"
                            (selectionChange)="
                                onSuperGroupSelectionChange($event)
                            "
                        ></div>
                    </ng-container>
                </div>

                <!--TODO tl-->
                <button
                    class="btn bg-transparent cmps-cdk-py-0dot5"
                    data-insight-snce-toggle="hide"
                    cmpsTooltipTrigger="Collapse selection"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
    </div>

    <cmps-wait-status
        *ngIf="
            state?.pending?.configReload ||
            state?.period?.pending?.periodType ||
            state?.superGroup?.pending
        "
    ></cmps-wait-status>

    <ng-container
        *ngIf="
            !state?.pending?.configReload &&
            !state?.period?.pending?.periodType &&
            !state?.superGroup?.pending &&
            state?.period?.eventDate &&
            !state?.period?.gotoDashboard &&
            state?.superGroup?.active
        "
    >
        <div
            cmpsInsightLegend
            class="insight-legend-pos"
            [metricThresholds]="state?.legend?.metricThresholds"
            [trends]="state?.legend?.trendsArrows"
            [showThresholdColours]="state?.activeView?.showThresholdColours"
            [showTrendArrows]="state?.activeView?.showTrendArrows"
            *ngIf="state?.activeView"
        ></div>

        <div class="insight-item">
            <span
                class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-300"
            >
                {{ state?.superGroup?.active?.name }}
            </span>
        </div>
    </ng-container>

    <div
        class="text-center"
        *ngIf="
            !state?.pending?.configReload &&
            !state?.period?.pending?.periodType &&
            !state?.superGroup?.pending &&
            (!state?.period?.eventDate ||
                state?.period?.gotoDashboard ||
                !state?.superGroup?.active ||
                !state?.activeView)
        "
    >
        {{ i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>

    <div
        [class]="'insight-underlay ' + _sheet.classes.underlay"
        [ngClass]="{
            'is-overlaid': state?.activeViewPillar && state?.activeViewMetric
        }"
        *ngIf="
            !state?.pending?.configReload &&
            !state?.period?.pending?.periodType &&
            !state?.superGroup?.pending &&
            state?.period?.eventDate &&
            !state?.period?.gotoDashboard &&
            state?.superGroup?.active &&
            state?.activeView
        "
    >
        <div
            cmpsHumanInsightVisual
            [view]="state?.activeView"
            [metrics]="state?.configs[state?.activeConfig]?.metrics"
            [periodType]="state?.period?.periodType"
            [eventDate]="state?.period?.eventDate"
            [superGroup]="state?.superGroup?.active"
            [configUserInfo]="state?.configUserInfo"
            [roleHierarchy]="state?.roleHierarchy"
            [optionalColumns]="state?.optionalColumns"
            (itemClick)="onVisualItemClick($event)"
        ></div>

        <div
            class="insight-overlay"
            [ngClass]="_sheet.classes.overlay"
            *ngIf="state?.activeViewPillar && state?.activeViewMetric"
        >
            <div class="insight-overlay-content">
                <button
                    class="btn bg-transparent insight-overlay-close"
                    tabindex="-1"
                    (click)="onCloseOverlay()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>

                <div class="insight-overlay-head">
                    <div class="d-flex align-items-center">
                        <div
                            cmpsInsightSelectedVisualItem
                            [pillarName]="state?.activeViewPillar?.name"
                            [metricName]="state?.activeMetric?.shortName"
                            [dataMetric]="state?.activeDataMetric"
                            [showThresholdColours]="
                                state?.activeView?.showThresholdColours
                            "
                            [showTrendArrows]="
                                state?.activeView?.showTrendArrows
                            "
                        ></div>

                        <!--maybe overkill as its own comp, but intended-->
                        <div
                            cmpsInsightPresentation
                            [selection]="state?.presentAs"
                            (selectionChange)="
                                onPresentationSelectionChange($event)
                            "
                        ></div>
                    </div>

                    <div
                        cmpsInsightPath
                        [paths]="state?.configs[state?.activeConfig]?.paths"
                        [path]="state?.activePath"
                        (pathChange)="onPathChange($event)"
                        *ngIf="
                            !state?.superGroup?.active?.extra?.teamSuperGroup
                        "
                    ></div>

                    <div class="d-flex align-items-center">
                        <div
                            cmpsInsightCustomize
                            [pillars]="
                                state?.presentAs === PresentationView.GRID
                            "
                            [pillarsPillars]="state?.activeView?.pillars"
                            [pillarsSelection]="state?.activePillars"
                            (pillarsSelectionChange)="
                                onPillarsSelectionChange($event)
                            "
                            [pillarsCanSelect]="canSelectPillar"
                            [columns]="true"
                            [columnsColumns]="
                                state?.presentAs === PresentationView.GRID
                                    ? state?.grid?.supportedColumns
                                    : state?.trend?.supportedColumns
                            "
                            [columnsSelection]="
                                state?.presentAs === PresentationView.GRID
                                    ? state?.grid?.activeColumns
                                    : state?.trend?.activeColumns
                            "
                            (columnsSelectionChange)="
                                onColumnsSelectionChange($event)
                            "
                            [metrics]="
                                state?.presentAs === PresentationView.TREND
                            "
                            [metricsMetrics]="
                                state?.configs[state?.activeConfig]?.metrics
                            "
                            [metricsPillars]="state?.activeView?.pillars"
                            [metricsSelection]="state?.activeMetrics"
                            (metricsSelectionChange)="
                                onMetricsSelectionChange($event)
                            "
                            *ngIf="!state?.pending?.supportedColumns"
                        ></div>

                        <div
                            class="ml-5 insight-export"
                            *ngIf="state?.presentAs === PresentationView.GRID"
                        >
                            <button
                                class="btn bg-transparent pr-0 pl-0"
                                (click)="onExportGridClick()"
                            >
                                <cmps-icon
                                    class="cmps-cdk-fill-blue-100 cmps-cdk-mr-0dot5"
                                    svgIcon="download"
                                ></cmps-icon>
                                <span>Export Data</span>
                            </button>
                        </div>
                    </div>

                    <div
                        class="insight-presentation-trend"
                        *ngIf="state?.presentAs === PresentationView.TREND"
                    >
                        <div>
                            <button
                                type="button"
                                class="btn bg-transparent pr-0 pl-0"
                                data-toggle-trend-users
                                (click)="onToggleTrendFirstGridColumn()"
                            >
                                <cmps-icon
                                    class="cmps-cdk-fill-blue-100"
                                    [svgIcon]="
                                        !state?.trendHideFirstGridColumn
                                            ? 'chevron-left-circle'
                                            : 'chevron-right-circle'
                                    "
                                ></cmps-icon>
                                <span>{{
                                    (!state?.trendHideFirstGridColumn
                                        ? i18n._7135_HIDE_USERS
                                        : i18n._7134_SHOW_USERS
                                    ) | translate
                                }}</span>
                            </button>
                        </div>

                        <div
                            cmpsInsightPeriod
                            class="text-right"
                            [allowedPeriodTypes]="state?.trend?.periods"
                            [periodType]="state?.trend?.periodType"
                            (periodTypeChange)="onTrendPeriodTypeChange($event)"
                        ></div>
                    </div>
                </div>

                <div
                    class="insight-overlay-body"
                    *ngIf="!state?.pending?.supportedColumns"
                >
                    <div
                        cmpsHumanInsightGrid
                        [config]="context.config"
                        [view]="state?.activeView"
                        [metrics]="state?.configs[state?.activeConfig]?.metrics"
                        [periodType]="state?.period?.periodType"
                        [cacheDates]="cacheDates"
                        [eventDate]="state?.period?.eventDate"
                        [superGroup]="state?.superGroup?.active"
                        [viewPillar]="state?.activeViewPillar"
                        [viewMetric]="state?.activeViewMetric"
                        [path]="state?.activePath"
                        [roleHierarchy]="state?.roleHierarchy"
                        [pillars]="state?.activeView?.pillars"
                        [pillarSelection]="state?.activePillars"
                        [columns]="state?.grid?.supportedColumns"
                        [columnSelection]="state?.grid?.activeColumns"
                        [maxSelection]="20"
                        [configUserInfo]="state?.configUserInfo"
                        [className]="_sheet.classes.overlayBody"
                        [maxHeight]="overlayBodyHeight"
                        [trendVisible]="
                            state?.presentAs === PresentationView.TREND
                        "
                        [trendHideFirstGridColumn]="
                            state?.trendHideFirstGridColumn
                        "
                        (layout)="gridClassName = $event"
                        (newTabClick)="onGridNewTabClick($event)"
                        (selectionChange)="onGridSelectionChange($event)"
                    ></div>

                    <div
                        cmpsHumanInsightTrend
                        [metrics]="state?.configs[state?.activeConfig]?.metrics"
                        [eventDate]="state?.period?.eventDate"
                        [columnSelection]="state?.trend?.activeColumns"
                        [gridSelection]="gridSelection"
                        [metricSelection]="state?.activeMetrics"
                        [className]="_sheet.classes.overlayBody"
                        [gridClassName]="gridClassName"
                        *ngIf="state?.presentAs === PresentationView.TREND"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template
    #dashboardDialogTpl
    let-dismiss="dismiss"
>
    <div class="modal-header">
        <div
            class="modal-title h4"
            role="heading"
            aria-level="1"
        >
            {{ 'Go To Dashboard' | translate }}
        </div>
        <button
            type="button"
            class="close"
            [attr.aria-label]="i18n._763_CLOSE | translate"
            (click)="dismiss()"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="modal-body">
        <span>{{
            'The selected date is outside the accepted range.' | translate
        }}</span>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            (click)="dismiss()"
        >
            {{ i18n._763_CLOSE | translate }}
        </button>
        <a
            class="btn btn-primary"
            [routerLink]="['internal', 'webform']"
            [queryParams]="{ relativeUrl: dashboardUrl }"
            >{{ 'Go To Dashboard' | translate }}</a
        >
    </div>
</ng-template>

<ng-template
    #atLeastOnePillarDialogTpl
    let-dismiss="dismiss"
>
    <div class="modal-header">
        <button
            type="button"
            class="close"
            [attr.aria-label]="i18n._763_CLOSE | translate"
            (click)="dismiss()"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="modal-body">
        <span>{{ 'Select at least one pillar.' | translate }}</span>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-primary"
            (click)="dismiss()"
        >
            {{ i18n._763_CLOSE | translate }}
        </button>
    </div>
</ng-template>
